import {combineReducers} from "redux";
import auth from "./auth";
import user from "./user";
import warehouse from "./warehouse";
import notification from "./notification";
import error from "./error";
import book from "./book";

export default combineReducers({
  auth,
  user,
  warehouse,
  notification,
  error,
  book
});


// WEBPACK FOOTER //
// ./src/store/reducers/index.js